/*****************************************************************************************
 * 설명 : 관리자 > 컨텐츠관리 > 기본 메뉴 설정
 * URI : /admin/cms/menuList
*****************************************************************************************/
import Button from '@mui/material/Button';
import { AgGridReact } from 'ag-grid-react';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from "yup";

import useGridConfig from 'hooks/useGridConfig';

import BtnAgGridSave from 'components/btnAgGridSave';
import { BtnRefresh, BtnSearch, CurrencyFormat, CustomPagenation } from 'components/common';
import { ButtonEx, InputEx } from 'components/inputEx';
import alertMsg from 'components/message';
import { MESSAGE_DELAY } from 'config/config';

import { Restful } from 'service/restful';
import { comma } from 'service/utils';

import SaveIcon from '@mui/icons-material/Save';
import NewIcon from 'assets/images/icon_new.svg';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const TabBoardList = ( props ) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const [gridApi, setGridApi] = useState({});
  const [list, setList] = useState([]);

  const initialValues = {
    searchText: '',
    pageNo: 1,
    pageRow: 20,
    totalPage: 1
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object().shape({
      searchText: Yup.string().max(30, "30자리"),
    }),
    onSubmit: (values) => {
      getList();
    }
  });


  // ag grid 컬럼 선언
  const [columnDefs, setColumnDefs] = useState([
    { headerName: '관리번호(관리자용)', field: 'seq', width: 30, cellClass: 'center', flex: 0,
      headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true },
    { headerName: '번호', field: 'rowIndex', width: 100, cellClass: 'cp right',
      valueGetter: (params) => {
        if( params.data.isNotice === '1' || params.data.isNotice === 1 )
          return '공지';
        else if( params.data.noticeCount > 0 )
          return comma(params.data.total - ((params.data.pageNo - 1) * params.data.pageRow) - params.node.rowIndex);
        else
          return comma(params.data.total - ((params.data.pageNo - 1) * params.data.pageRow) - params.node.rowIndex);
      }
    },
    {headerName: '그룹', field: 'groupId', width: 150, cellClass: 'cp center'},
    {headerName: '제목', field: 'subject', width: 400, cellClass: 'cp',
      cellRenderer: function (params) {
        return (
          <>
            {params.data.subject}

            { params.data.commentCount > 0 &&
              <span className="ml5 f11">
                [{params.data.commentCount}]
              </span>
            }

            { params.data.uploadFileCount > 0 &&
              <SaveIcon className="ml5 vm f12" style={{color: '#4846b7', marginBottom: '4px'}} />
            }

            { parseInt(params.data.isNew) === 1 &&
              <img src={NewIcon} alt="new" className="ml5" style={{width: '10px', height: '10px'}} />
            }

          </>
        );
      }
    },
    {headerName: '작성자', field: 'creatorName', width: 150, cellClass: 'cp' },
    {headerName: '작성일시', field: 'createDate', width: 170, cellClass: 'cp center' },
    {headerName: '조회수', field: 'hit', width: 100, cellClass: 'cp right', valueFormatter: CurrencyFormat },
    {headerName: '수정', field: 'modify', cellClass: 'cp center', width: 100,
      cellRenderer: function (params) {
        return <Button color="secondary" variant="outlined" className="gridBtn1" onClick={() => {boardEdit(params.data)}}>수정</Button>;
      }
    }
  ]);

  const [gridConfig, setGridUpdate] = useGridConfig(1, setColumnDefs);

  /***************************************************************************************
   * 설명 : 컨텐츠 데이터 로그 가져오기
  ***************************************************************************************/
  const getList = () => {
    let params = {
      program: 'admin',
      service: 'board',
      action: 'getBoardList',
      version: '1.0',
      boardId: props.data.boardId,
      pageRow: formik.values.pageRow,
      pageNo: formik.values.pageNo,
      searchText: formik.values.searchText
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result && response.data.data && response.data.data.length > 0 ) {
        setList([
          ...response.data.data.map((item) => {
            return {
              ...item,
              total: response.data.totalCount,
              noticeCount: response.data.noticeCount,
              listCount: response.data.listCount,
              pageNo: formik.values.pageNo,
              pageRow: formik.values.pageRow,
            }
          })
        ]);

        /*
        if( response.data.data[0].groupId === '' || response.data.data[0].groupId === null ) {
          gridApi.columnModel.setColumnVisible('groupId', false);
        }
        */

        formik.setFieldValue("totalPage", response.data.totalPage);

      } else {
        setList([]);
        formik.setFieldValue("totalPage", 0);
        formik.setFieldValue("pageNo", 1);
        formik.setFieldValue("pageRow", 1000);
      }
    })
  }

  /***************************************************************************************
   * 설명 : 게시판 등록
  ***************************************************************************************/
  const boardAdd = (listData) => {
    props.setBoardData([]);
    props.setBoardFunc('write');
  }

  /***************************************************************************************
   * 설명 : 게시판 수정
  ***************************************************************************************/
  const boardEdit = (listData) => {
    props.setBoardData(listData);
    props.setBoardFunc('write');
  }

  /***************************************************************************************
   * 설명 : 게시글 삭제
  ***************************************************************************************/
  const deleteBoard = () => {
    let nodes = gridApi.getSelectedRows();

    if( nodes.length < 1 ) {
      alertMsg("삭제할 게시글을 선택하시기 바랍니다.", "W", MESSAGE_DELAY);
      return;
    }

    if( ! window.confirm("선택한 게시글을 삭제하시겠습니까?") ) return;

    let params = {
      program: 'admin',
      service: 'board',
      action: 'deleteBoard',
      version: '1.0',
    }

    params.seq = nodes.map((item) => item.seq).join();
    params.boardId = nodes[0].boardId;

    getApi("post", params).then( response => {
      if( response !== undefined && response.data.result ) {
        alertMsg(response.data.message, "S", MESSAGE_DELAY);

        getList();
      } else {
        alertMsg(response?.data?.message || '서버와의 통신에 실패하였습니다.', 'E', MESSAGE_DELAY);
      }
    });
  }

  /***************************************************************************************
   * 설명 : 검색 초기화
  ***************************************************************************************/
  const initSearch = () => {
    formik.setValues(initSearch);
    formik.handleSubmit();
  }

  /***************************************************************************************
   * 설명 : 데이터 로딩 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 2 && props.data?.boardId !== '' ) {
      getList();
    }

    // eslint-disable-next-line
  }, [props.tabIndex, props.data]);

  /***************************************************************************************
   * 설명 : 데이터 로딩 처리
  ***************************************************************************************/
  useEffect(() => {
    if( props.tabIndex === 2 && props.data?.boardId !== '' ) {
      getList();
    }

    // eslint-disable-next-line
  }, [formik.values.pageNo])

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <>
      {props.siteSeq === '' &&
        <section className="pt10">
          <div className="menu-list-add-background">
            사이트를 선택 후에 '메뉴등록' 혹은 '메뉴선택'을 진행해주세요.
          </div>
        </section>
      }

      {props.siteSeq !== '' &&
        <>
          { ( props.data.seq === undefined || props.data.siteSeq === undefined ) &&
						<section className="pt10">
							<div className="menu-list-add-background">
								메뉴를 선택하시기 바랍니다.
							</div>
						</section>
					}

          { props.data.seq !== undefined && props.data.siteSeq !== undefined &&
            <>
              {
                ( props?.data?.boardId === null || props?.data?.boardId === '' ) &&
                <section className="pt10">
                  <div className="menu-list-add-background">
                    게시판 아이디를 먼저 설정해 주시기 바랍니다.
                  </div>
                </section>
              }

              {
                ( props.data?.boardId !== null && props.data?.boardId !== '' ) &&
                <section className="">
                  <form onSubmit={formik.handleSubmit}>
                    <header className="admin-cms-search-header">
                      <div className="left">
                        <BtnRefresh click={() => initSearch()}></BtnRefresh>
                        <BtnSearch></BtnSearch>
                        <BtnAgGridSave click={setGridUpdate}></BtnAgGridSave>

                        <InputEx
                          name="searchText"
                          fullWidth={false}
                          formik={formik}
                          label="제목, 내용 검색"
                          style={{width: '250px'}}
                        />
                      </div>

                      <div className="right">
                        {/*
                        <ButtonEx
                          title="글이동"
                          auth="authModify"
                          color="error"
                          className="Btn ml5"
                          variant="outlined"
                          onClick={() => {
                          }}
                        />
                        */}

                        <ButtonEx
                          title="글삭제"
                          auth="authDelete"
                          color="error"
                          className="Btn ml5"
                          variant="outlined"
                          onClick={() => deleteBoard()}
                        />

                        <ButtonEx
                          title="글등록"
                          auth="authWrite"
                          color="primary"
                          className="ml5"
                          variant="contained"
                          onClick={() => {
                            boardAdd();
                          }}
                        />
                      </div>
                    </header>
                  </form>
                  <section className="ag-theme-balham grid mt10" style={{height: 'calc(100vh - 230px)'}}>
                    <AgGridReact
                      defaultColDef={{
                        sortable: true,
                        resizable: true,
                        filter: false,
                        lockVisible: true
                      }}
                      rowSelection = {'multiple'}
                      columnDefs={columnDefs}
                      rowData={list}
                      onGridReady={(event) => {
                        gridConfig(event.columnApi);
                        setGridApi(event.api);
                      }}
                      rowDragManaged={true}
                      rowDragMultiRow={true}
                      animateRows={true}
                      overlayNoRowsTemplate = "검색된 내용이 없습니다."
                    />
                  </section>

                  <div className="mt10">
                    <div className="fl">
                      <CustomPagenation
                        currPage={formik.values.pageNo}
                        totalPage={formik.values.totalPage}
                        change={(event, page) => {
                          formik.setFieldValue("pageNo", (page === undefined) ? formik.values.pageNo : page );
                        }}
                      ></CustomPagenation>
                    </div>
                    <div className="fr">
                      검색 : {formik.values.pageNo} / {formik.values.totalPage}
                    </div>
                  </div>
                </section>
              }
            </>
          }
        </>
      }
    </>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default TabBoardList;